import { CheckCircleFilled, ExclamationCircleFilled } from "@ant-design/icons";
import { Form } from "antd";
import React, { useEffect, useRef, useState } from "react";
import upload from "../../assets/images/upload.svg";
import { useSetRecoilState } from "recoil";
import { getPresignedAuthURL } from "../../services/httpCalls";
import { showloader } from "../../store/gloabalState";
import useNotify from "../../utils/useNotify";
import PreviewDocsModalProbe from "./previewDocsModalProbe";
import { checkFileExtension } from "../../utils/check-file-extension";
const DocsUploadAuthSig = ({
  name,
  type,
  doc,
  files,
  filesAdded,
  selectionValue,
  setFilesAdded,
}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [filesList, setFilesList] = useState(files);
  const [filesUploaded, setFilesUploaded] = useState({
    AUTHORIZED_SIGNATORY_ADHAAR: "",
    AUTHORIZED_SIGNATORY_PAN: "",
  });
  const [errorMessage, setErrorMessage] = useState("");
  const setShowLoader = useSetRecoilState(showloader);
  const inputRef = useRef();
  const notify = useNotify();

  const uploadFileToS3 = (url, file) => {
    return fetch(url, {
      method: "PUT",
      body: file,
      headers: { "Content-Type": file.type },
    });
  };

  const resetFile = () => {
    // setErrorMessage('')
    setFileName("");
    setSelectedFile(null);
    inputRef.current.value = null;
  };

  const cdocsUpload = async (files, docType) => {
    let preSignedUrl;
    if (files.length) {
      setShowLoader(true);
      let orgId = localStorage.getItem("orgId");
      await getPresignedAuthURL(orgId, files[0].name)
        .then(async (res) => {
          preSignedUrl = res?.preSignedUrl?.split("?")[0];
          await uploadFileToS3(res.preSignedUrl, files[0])
            .then((res) => {
              if (res) {
              }
              let doc_ = {
                documentType: name,
                url: preSignedUrl,
              };
              let files_ = [];
              if (filesAdded?.length) {
                files_ = filesAdded;
                files_.forEach((item, i) => {
                  if (item.documentType === name || item.type === name) {
                    files_[i] = doc_;
                  } else {
                    files_.push(doc_);
                  }
                });
              } else {
                files_.push(doc_);
                // setFilesAdded(files_)
              }
              // files_.push(doc_)
              setFilesAdded(files_);
              setErrorMessage("");
              return;
            })
            .catch((err) => {
              notify.error("Error while uploading to S3");
              resetFile();
            })
            .finally(() => setShowLoader(false));
        })
        .catch((err) => {
          notify.error("Error genrating Presigned URL");
          resetFile();
        })
        .finally(() => setShowLoader(false));
    }
  };
  const validFileSize = (size, name) => {
    if (size * 0.001 >= 1024 * 10) {
      notify.error("File size is more than 10MB!");
      setErrorMessage("Please upload file with size less than 10MB");
      resetFile();
      return false;
    }
    return true;
  };

  function hasSpecialCharacters(filename) {
    const regex = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?~]/;
    return regex.test(filename);
  }

  const handleFileSelect = (e) => {
    if (e.target.files?.length) {
      if (!checkFileExtension(e.target?.files[0]?.name)) {
        notify.error("Please upload a file with proper extension!");
        resetFile();
      }
      if (!hasSpecialCharacters(e.target?.files[0]?.name)) {
        let sizeofFile = e.target.files[0]?.size;
        if (validFileSize(sizeofFile, e.target.name)) {
          setSelectedFile(e?.target?.files?.[0]);
          setFileName(e?.target.files[0]?.name);
          cdocsUpload(e.target.files, e.target.name);
        }
      } else {
        setErrorMessage(
          "Please remove special characters from file name such as [,(),#,!,@,~,&,$,%,*,/,|,?,<,} and re-upload eg. XYZ.pdf or xyz123 file.pdf"
        );
        resetFile();
      }
    } else {
      notify.error("No file Selected!");
      resetFile();
    }
  };

  useEffect(() => {
    if (doc) {
      setFileName(doc.name);
      let auth_files = filesUploaded;
      auth_files[doc.type] = doc?.s3Url?.split("amazonaws.com/")[1];
      setFilesUploaded(auth_files);
    } else {
      resetFile();
    }
  }, [doc, name, type]);

  const isDoucmentRequired =
    selectionValue?.[0] !== "inward" && (fileName ? false : true);

  return (
    <Form.Item
      labelCol={{ span: 16 }}
      label={
        <>
          {
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  fontWeight: "500",
                  fontSize: ".9rem",
                  letterSpacing: ".5px",
                }}
              >
                {type}
              </span>{" "}
              {fileName || selectionValue?.[0] === "inward" ? (
                <>
                  <CheckCircleFilled
                    style={{
                      color: "green",
                      fontSize: "16px",
                    }}
                  />
                  <PreviewDocsModalProbe url={filesUploaded[name]} />
                </>
              ) : doc?.type === name ? (
                <CheckCircleFilled
                  style={{
                    color: "green",
                    fontSize: "16px",
                  }}
                />
              ) : (
                <ExclamationCircleFilled
                  style={{
                    color: "red",
                    fontSize: "16px",
                  }}
                />
              )}
            </div>
          }
        </>
      }
      name={name}
      rules={[
        {
          required: isDoucmentRequired,
          message: "Please upload document",
        },
      ]}
    >
      <div style={{ margin: "0.5rem 0" }}>
        <div className={`${errorMessage ? "border-error" : "border"}`}>
          <div className="file-upload">
            <img src={upload} alt="" />
            {fileName ? (
              <h4 className="filename_text"> {fileName}</h4>
            ) : (
              files?.forEach((elem) => {
                if (elem.type === name) {
                  return <h4 className="filename_text">{elem.name}</h4>;
                }
                //  else {
                //     <h4 className='filename_text'> {fileName ? fileName : files?.forEach((elem: any) => elem.type === name ? elem.name : "") ? "No file Selected" : ""}</h4>
                // }
              })
            )}
            <input type="file" onChange={handleFileSelect} ref={inputRef} />
            <div />
          </div>
        </div>
        <p className="error_message">{errorMessage ? errorMessage : ""}</p>
      </div>
    </Form.Item>
  );
};

export default DocsUploadAuthSig;
